module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/match/match.component.css
// module id = ./src/app/match/match.component.css
// module chunks = main